
import { ObserveVisibility } from "vue-observe-visibility"

export default {
  name: "StatisticItem",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  directives: {
    ObserveVisibility,
  },

  methods: {
    onObserveVisibility: function (visible, entry) {
      if (!visible) {
        return;
      }
      this.$refs.refCount.innerText = "";
      this.startCounter();
    },
    startCounter: function () {
      const fullCount = Number.parseFloat(String(this.item.count || "").replace(/\s/g, ''));
      const step = Math.floor(fullCount / 20);
      const current = Number.parseFloat(this.$refs.refCount?.innerText || "0");

      if (current === fullCount) {
        return
      }
      let newCount = current + step;
      if (newCount > fullCount) {
        newCount = fullCount;
      }

      this.$refs.refCount.innerText = newCount;

      setTimeout(() => {
        this.startCounter();
      }, 100);
    }
  }
}
